import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DOMPurify from "isomorphic-dompurify";
import { marked } from "marked";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Loader from "./Loader";
import ReactTost from "./ReactTost";

const FreeChatbot = () => {
  const [loading, setLoading] = useState(false);
  const [isLoading] = useState(false);
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const chatContainerRef = useRef(null);
  const chatMessageRef = useRef(null);
  const [headerLogo, setHeaderLogo] = useState();
  const [sid, setSid] = useState();
  const [message, setMessage] = useState();
  const [isDisable, setIsDisable] = useState(false);
  const [chatHistoryData, setChatHistoryData] = useState([]);
  const [isFirst, setIsFirst] = useState(true);
  const [color, setColor] = useState("#05204a");
  const [headerColor, setHeaderColor] = useState("");
  const [name, setName] = useState();
  const [initialMsg, setInitialMsg] = useState();
  const [messageToChat, setMessageToChat] = useState(false);
  const [visibility, setVisibility] = useState();
  const [suggestedQuestion, setSuggestedQuestion] = useState([]);
  const [messageType, setMessageType] = useState();
  const [companyLogo, setCompanyLogo] = useState();
  const [chatInstructionText, setChatInstructionText] = useState();
  // const [, setMessageCount] = useState(0);
  const [messageTime, setMessageTime] = useState(0);
  // const [, setUpdateId] = useState(0);
  // const [, setLimit] = useState();
  // const [, setSeconds] = useState();
  // const [, setErrorDisplay] = useState();
  const [type, setType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [perUserErrorDisplay, setPerUserErrorDisplay] = useState(false);
  const [isOpen, setIsopen] = useState(false);
  const [typeIndicator, setTypeIndicator] = useState(false);
  const chatRef = useRef(null);
  let checkMsg = "";
  const { t } = useTranslation();
  const [perUserError] = useState(
    "Sorry, I have a limit of Questions per visitor per day. Please come back later"
  );

  useEffect(() => {
    const getSid = () => {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/init/${id}`)
        .then((response) => {
          if (response.data) {
            if (response.data.sid) {
              localStorage.setItem(id, response.data.sid);
              setSid(response.data.sid);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (id) {
      const sidList = localStorage.getItem(id);
      setSid(sidList);
      if (!sidList) {
        getSid();
      }
    }
  }, [API_URL, API_VERSION, id]);

  async function userQuestion() {
    let isNew = 1;
    let isKey = chatHistoryData.length;
    let __msg__ = "";
    await fetchEventSource(
      `${process.env.REACT_APP_STRING_CHAT_URL}/bot/query-stream/${id}?text=${message}&sid=${sid}`,
      {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        onopen(res) {
          if (res.ok && res.status === 200) {
            console.log("Connection made ", res);
          } else if (
            res.status >= 400 &&
            res.status < 500 &&
            res.status !== 429
          ) {
            console.log("Client side error ", res);
          }
        },
        onmessage(event) {
          const messageText = JSON.parse(event.data).token;
          if (messageText !== "[END]") {
            // __msg__ = __msg__ + messageText.replace(/\n/g, "<br>");
            // const urlRegex = /(https?:\/\/[^\s,;'"`<>\])}]+)/g;
            // const parts = __msg__.split(urlRegex);
            // let ___msg___ = "";
            // parts.map((part, index) => {
            //   if (part.match(urlRegex)) {
            //     const url = part.match(urlRegex)[0];
            //     const punctuation = /[.,'"()]+$/;
            //     let cleanedUrl = url;
            //     const match = url.match(punctuation);
            //     let lastPunctuation = "";
            //     if (match) {
            //       lastPunctuation = match[0];
            //       cleanedUrl = url.slice(0, -1);
            //     }

            //     // Handle the URL
            //     let formattedUrl = `
            //       <a
            //         target="_blank"
            //         rel="noopener noreferrer"
            //         href=${cleanedUrl}
            //       >
            //         ${cleanedUrl}
            //       </a>
            //     `;

            //     if (match) {
            //       formattedUrl += lastPunctuation;
            //     }

            //     ___msg___ += formattedUrl;
            //   } else {
            //     ___msg___ += `${part}`;
            //   }
            // });
            __msg__ += messageText;
            
            const userMessage = (
              <li className="sender chatGPTreplay">
                <div className="cont">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        marked.parse(__msg__)
                      ),
                    }}
                  ></span>
                </div>
              </li>
            );
            if (isNew) {
              isNew = false;
              setChatHistoryData((prevHistory) => [
                ...prevHistory,
                userMessage,
              ]);
            } else {
              setChatHistoryData((prevHistory) => {
                const updatedHistory = [...prevHistory];
                updatedHistory[parseInt(isKey + 1)] = userMessage;
                return updatedHistory;
              });
            }
          }
        },
        onclose() {
          setTypeIndicator(false);
          console.log("Connection closed by the server");
        },
        onerror(err) {
          setTypeIndicator(false);
          console.log("There was an error from server", err);
        },
      }
    );
  }

  function callQuestion() {
    setIsDisable(() => true);
    CheckUSerMessageLimit()
      .then(async (response) => {
        setIsDisable(() => false);
        if (response) {
          setPerUserErrorDisplay(false);
          chatMessageRef.current.value = "";
          if (sid && message) {
            const userMessage = (
              <li className="repaly userInput" style={{ background: color }}>
                <div className="cont">
                  <span>{message}</span>
                </div>
              </li>
            );
            setChatHistoryData((prevHistory) => [...prevHistory, userMessage]);
            setMessageToChat(false);
            setMessage();
            setTypeIndicator(true);
            await userQuestion();
          }
        } else {
          setPerUserErrorDisplay(true);
        }
        chatMessageRef.current.focus();
        return false;
      })
      .catch((error) => {
        setIsDisable(() => false);
        console.log(error);
        chatMessageRef.current.focus();
      });
  }

  function checkEmptyMsg() {
    checkMsg = message;
    if (checkMsg === "" || checkMsg === undefined || checkMsg === null) {
      return false;
    } else {
      checkMessageLimit();
    }
  }

  function handleKeyPress(e) {
    e.preventDefault();
    checkMsg = message;
    console.log(checkMsg);
    if (checkMsg === "" || checkMsg === undefined || checkMsg === null) {
      return false;
    } else {
      callQuestion();
      return false;
    }
  }

  function checkMessageLimit() {
    setLoading(true);
    let sID = sid;

    axios
      .post(
        `${API_URL}/${API_VERSION}/bot/checkMessageLimit/${id}`,
        {
          sID,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.ans.limit === true) {
          console.log("calling question api");
          callQuestion();
        } else {
          setType("Danger");
          setMessage(t("Message Limit exceeded."));
          setShowAlert(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went wrong."));
        setShowAlert(true);
      });
  }

  // useEffect(() => {
  //   if (chatContainerRef && chatContainerRef.current) {
  //     chatContainerRef.current.addEventListener("DOMNodeInserted", (event) => {
  //       const { currentTarget: target } = event;
  //       target.scroll({ top: target.scrollHeight, behavior: "smooth" });
  //     });
  //   }
  // }, [chatHistoryData]);
  useEffect(() => {
    const container = chatContainerRef?.current;
    if (!container) return;
  
    const observer = new MutationObserver(() => {
      container.scroll({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    });
  
    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  
    return () => observer.disconnect();
  }, [chatHistoryData]);

  async function CheckUSerMessageLimit() {
    if (sid) {
      const messageCountResponse = await axios.post(
        `${API_URL}/${API_VERSION}/bot/checkMessageLimit/${id}`,
        {
          sID: sid,
          time: messageTime,
        }
      );
      return messageCountResponse.data.ans;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      axios
        .get(`${API_URL}/${API_VERSION}/bot/chatbot/${id}`)
        .then((response) => {
          if (response.data) {
            setVisibility(response.data.settings.visibility);
            // setMessageCount(response.data.settings.messageCount);
            setMessageTime(response.data.settings.messageLimit);
            if (response.data.chatInterface) {
              setMessageType(response.data.chatInterface.messageType);
              setColor(response.data.chatInterface.color);
              setHeaderColor(response.data.chatInterface.headerColor);
              setInitialMsg(response.data.chatInterface.initialMsg);
              setName(response.data.name);
              setCompanyLogo(response.data.chatInterface.companyLogo);
              setChatInstructionText(
                response.data.chatInterface.chatInstructionText
              );

              if (response.data.chatInterface.suggestedMsg) {
                setSuggestedQuestion(
                  response.data.chatInterface.suggestedMsg.split("\n")
                );
              }
              setHeaderLogo(response.data.chatInterface.headerLogo);
              const _userMessage = (
                <li className="sender chatGPTreplay">
                  <div className="cont">
                    <span>{response.data.chatInterface.initialMsg}</span>
                  </div>
                </li>
              );
              setChatHistoryData([]);
              setChatHistoryData((_prevHistory) => [
                ..._prevHistory,
                _userMessage,
              ]);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`${API_URL}/${API_VERSION}/rateLimit`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          if (response.data.length) {
            // setLimit(response.data[0].maxQuestion);
            // setSeconds(response.data[0].msgLimit);
            // setErrorDisplay(response.data[0].msgErr);
            // setUpdateId(response.data[0].id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [API_URL, API_VERSION, id, isFirst]);

  function resetChatUi() {
    const _userMessage = (
      <li className="sender chatGPTreplay">
        <div className="cont">
          <span>{initialMsg}</span>
        </div>
      </li>
    );
    setChatHistoryData([]);
    setChatHistoryData((_prevHistory) => [..._prevHistory, _userMessage]);
  }

  useEffect(() => {
    if (messageToChat && message) {
      callQuestion();
    }
  }, [messageToChat, message]);

  const buttonStyle = {
    pointerEvents: isDisable ? "none" : "auto",
  };

  const openProfile = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  return (
    <>
      <section className="chating_box">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        {visibility === "public" && (
          <Container>
            <Row className="justify-content-center py-4">
              <Col md={12}>
                <div className="chatingwrap">
                  <div className="chatarea">
                    <div
                      className="chating_head"
                      style={{ background: headerColor }}
                    >
                      <div className="brand">
                        <span>{name}</span>
                      </div>
                      <div className="actions">
                        <div className="refresh" onClick={() => resetChatUi()}>
                          <i className="fa-solid fa-rotate"></i>
                        </div>
                        <div className="menu" onClick={openProfile}>
                          <i class="fa-solid fa-bars"></i>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex w-100">
                      <div
                        className={`right_profileArea ${
                          isOpen === true ? "active" : ""
                        }`}
                      >
                        <div
                          className="closeProfile"
                          style={{ background: headerColor }}
                          onClick={openProfile}
                        >
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                        <div className="profile">
                          <img src={companyLogo ? companyLogo : ""} alt="" />
                        </div>
                        <div className="instruct">
                          <span>{chatInstructionText}</span>
                        </div>
                      </div>
                      <div className="left_chatArea">
                        <div className="chating_area" ref={chatContainerRef}>
                          {loading ? <Loader /> :
                            <ul>
                              {chatHistoryData}
                              {typeIndicator ? <li className="sender chatGPTreplay">
                                <div class="beat-loader">
                                  <div class="dot"></div>
                                  <div class="dot"></div>
                                  <div class="dot"></div>
                                </div>
                              </li> : null} 
                              <div ref={chatRef}/>
                            </ul>
                            }
                        </div>
                        <div className="sugbox">
                          {suggestedQuestion &&
                            suggestedQuestion.map((question) => {
                              return (
                                <span
                                  onClick={(e) => {
                                    setMessageToChat(true);
                                    setMessage(e.target.textContent);
                                  }}
                                >
                                  {question}
                                </span>
                              );
                            })}
                          {perUserErrorDisplay && (
                            <div className="text-danger">{perUserError}</div>
                          )}
                        </div>
                        <div className="chating_foot">
                          <form onSubmit={(e) => handleKeyPress(e)}>
                            <input
                              type="text"
                              className="form-control"
                              aria-label="message…"
                              placeholder={messageType}
                              ref={chatMessageRef}
                              disabled={isDisable}
                              onInput={(e) => setMessage(e.target.value)}
                            />
                            <button
                              style={{ background: color }}
                              type="button"
                              className="button send_btn"
                              onClick={() => checkEmptyMsg()}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-send"
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="#FFF"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="" />
                                <path d="M10 14l11 -11" />
                                <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                              </svg>
                            </button>
                          </form>
                          <div className="mt-3">
                            <span><a href="http://www.dignitytransportation.net/chatbot.php?liveChat=1"target="_blank" >Chat with live agent.</a></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {isLoading ? ( }
                    <Loader />
                   ) : (
                   )} */}
                </div>
              </Col>
            </Row>
          </Container>
        )}
        {visibility === "private" && (
          <div id="main">
            <div className="fof">
              <h1>{t("Error 404")}</h1>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default FreeChatbot;
